function findSubstringIndex(mainString, subString) {
    // Convert both strings to lowercase and remove accents
    const normalizedMain = mainString.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const normalizedSub = subString.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    // Use indexOf for case-insensitive search
    return normalizedMain.indexOf(normalizedSub);
}

export function customReplace(inputString, searchSubstring, replacement) {
    const index = findSubstringIndex(inputString, searchSubstring);
    const { length } = searchSubstring;
    // Extract the part of the original string before the replacement
    const prefix = inputString.slice(0, index);

    // Extract the part of the original string after the replacement
    const suffix = inputString.slice(index + length);

    // Concatenate the prefix, replacement, and suffix to get the final result
    const resultString = prefix + replacement + suffix;

    return resultString;
}
export default customReplace